module.exports = __webpack_public_path__ + "img/d8bfb87f-c212-4cac-8b77-28c91d173b21.5a61c724.png";